import { routerHelpers } from '@approvalmax/utils';
import * as Sentry from '@sentry/browser';
import { domain } from 'modules/data';
import { showReloginAcceptInvitationPopup } from 'modules/first-start/actions/common';
import { ReloginResult } from 'modules/first-start/reducers/moduleReducer';
import { getReloginResult } from 'modules/first-start/selectors/moduleSelectors';
import { useDispatch, useSelector } from 'modules/react-redux';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { storageService } from 'services/storage';

import { showVerifyEmailModule, verifyEmail } from '../actions';
import { VERIFY_EMAIL_PAGE_ID } from '../config';
import { decodeSignInUiState } from '../helpers';

const useVerifyEmailPageData = () => {
    const dispatch = useDispatch();
    const search = useLocation().search;
    const email = routerHelpers.getParamAsString(search, 'email', '');
    const code = routerHelpers.getParamAsString(search, 'code', '');
    const linkCode = routerHelpers.getParamAsString(search, 'linkCode', '');
    const state = routerHelpers.getParamAsString(search, 'state', '');
    const postAction = routerHelpers.getParamAsString(search, 'postAction', '');

    const reloginResult = useSelector(getReloginResult);

    useEffect(() => {
        const isAuthenticated = storageService.authenticated();

        if (isAuthenticated && reloginResult !== ReloginResult.AllowRelogin) {
            dispatch(showReloginAcceptInvitationPopup());

            return;
        }

        const loadPageData = async () => {
            if (linkCode) {
                let postAction: string | undefined = undefined;
                let app: domain.SsoLoginApplication | undefined = undefined;

                if (state) {
                    try {
                        const decodedUiState = decodeSignInUiState(state);

                        postAction = decodedUiState.afterLoginRedirectUrl;
                        app = decodedUiState.app;
                    } catch (error) {
                        Sentry.captureException(error);
                        Sentry.captureMessage(`Failed to decode params.state=${state}`);
                    }
                }

                dispatch(
                    showVerifyEmailModule({
                        linkCode,
                        postAction,
                        innerPageId: VERIFY_EMAIL_PAGE_ID,
                    })
                );
                dispatch(
                    verifyEmail({
                        app,
                        linkCode,
                        postAction,
                    })
                );
            } else {
                dispatch(
                    showVerifyEmailModule({
                        email,
                        code,
                        innerPageId: VERIFY_EMAIL_PAGE_ID,
                    })
                );
                dispatch(
                    verifyEmail({
                        email,
                        code,
                        postAction,
                    })
                );
            }
        };

        loadPageData();
    }, [code, dispatch, email, linkCode, postAction, state, reloginResult]);
};

export default useVerifyEmailPageData;
